import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { assureAwards, toggleAssureModal } from 'project/ducks/awards';

const mapStateToProps = ({ project: { awards } }) => {
  return {
    dialogVisible: awards.showingAssureModal,
    dialogHeader: "Assure you awards?",
    dialogMessage: "Assuring someone will win the award shows creatives that you're a \
                   committed client. This action CANNOT be undone.",
    primaryActionText: "Yes, Assure Awards"
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    toggleDialog: toggleAssureModal,
    submitAction: assureAwards,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./project/containers/assure_awards_modal.jsx